<template>
  <div class="container">
    <div class="left-side">
      <div class="page-header">
        <div>CUSTOMERS</div>
        <p style="">{{customer.name}}</p>
      </div>
      <div class="card">
        <div class="form">
          <div class="form__group form__group--spaced">
            <label>Phone</label>
            <input
              class="input input__round"
              style="width: 100%; max-width: 350px"
              v-model="customer.phone"
            >
          </div>
          <div class="form__group form__group--spaced">
            <label>Name</label>
            <input
              class="input input__round"
              style="width: 100%; max-width: 350px"
              v-model="customer.name"
            >
          </div>
          <div class="form__group form__group--spaced">
            <label>Customer Address</label>
            <input
              class="input input__round"
              style="width: 100%; max-width: 350px"
              v-model="customer.address"
            >
          </div>
        </div>
        <div class="form__actions">
          <Button
            text="Save"
            class="btn btn__primary"
            style="margin-left: auto; display: block"
            @on-click="editCustomer"
            :loading="loading"
          />
        </div>
      </div>
    </div>
    <div class="right-side">
      <div class="header page-header">
        <div>Invoices</div>
        <img
          src="../../assets/agreement_button.png"
          style="cursor: pointer;"
          @click="goToCreate()"
        >
        <!-- <Button text="Create Invoice" class="btn btn__primary" @on-click="goToCreate"/> -->
      </div>
      <div class="card" style="margin-top: 35px;">
        <table class="has-links" style="width:100%">
            <col width="10%">
            <col width="15%">
            <col width="10%">
            <col width="15%">
            <col width="10%">
            <col width="20%">
            <col width="20%">
          <tr>
            <SortItem title="ID" @set-sort="setSort" sortKey="id" :sort="sort"/>
            <SortItem
              title="Invoice Number"
              @set-sort="setSort"
              sortKey="invoice_number"
              :sort="sort"
            />
            <SortItem title="Total amount" @set-sort="setSort" sortKey="total_amount" :sort="sort"/>
            <SortItem title="Due Date" @set-sort="setSort" sortKey="due_date" :sort="sort"/>
            <SortItem title="Status" @set-sort="setSort" sortKey="status" :sort="sort"/>
            <SortItem title="Created at" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
            <SortItem title="Updated at" @set-sort="setSort" sortKey="updated_at" :sort="sort"/>
          </tr>
          <tr v-for="invoice in customer.invoices.data" :key="invoice.id" class="table-row" @click="goToInvoiceDetails(invoice.id)">
            <td>{{invoice.id}}</td>
            <td>{{invoice.invoice_number}}</td>
            <td>{{invoice.total_amount}}</td>
            <td>{{moment(invoice.due_date).format('DD.MM.YYYY')}}</td>
            <td><Label :status="invoice.status"/></td>
            <td>{{moment(invoice.created_at).format('DD.MM.YYYY  HH:MM')}}</td>
            <td>{{moment(invoice.updated_at).format('DD.MM.YYYY  HH:MM')}}</td>
          </tr>
        </table>
      </div>
      <div
        class="paginate__wrapper"
        v-if="customer.invoices.last_page && customer.invoices.last_page > 1"
      >
        <paginate
          :page-count="customer.invoices.last_page || 1"
          :prev-text="'Prev'"
          :click-handler="onPageChange"
          :next-text="'Next'"
          :container-class="'paginate'"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../partials/Button";
import Label from "../partials/Label";
import SortItem from "../partials/SortItem.vue";
import Paginate from "vuejs-paginate";
import moment from 'moment'
import * as api from "./api.js";
export default {
  name: "CustomerDetails",
  components: {
    Button,
    Label,
    Paginate,
    SortItem
  },
  created() {
    this.fetchCustomer();
  },
  methods: {
    fetchCustomer: async function(paginate) {
      let response;
      response = await api.fetchCustomer(
        this.$route.params.id,
        this.page,
        this.sort
      );
      if (paginate) {
        this.customer = {
          ...this.customer,
          invoices: response.invoices
        };
      } else {
        this.customer = response;
        document.title = this.customer.name + ' | PayGate Invoice'
      }
    },
    setSort(sort) {
      if (this.sort.value == sort) {
        if (this.sort.direction == "asc") {
          this.sort.direction = "desc";
        } else {
          this.sort.direction = "asc";
        }
      } else {
        this.sort.value = sort;
        this.sort.direction = "asc";
      }
      this.fetchCustomer(true);
    },
    goToCreate() {
      this.$router.push({
        path: "/dashboard/invoices/create",
        query: { customer: this.$route.params.id }
      });
    },
    goToInvoiceDetails(id) {
      this.$router.push({
        path: `/dashboard/invoices/${id}`
      });
    },
    editCustomer: async function() {
      try {
        await api.editCustomer(this.customer);
        this.$toasted.success("Customer edited successfully", {
          className: "success-toast"
        });
      } catch (e) {
          let err_msg = 'Something went wrong'
          Object.keys(e.response.data.errors).map(key => err_msg = e.response.data.errors[key][0])
          this.$toasted.error(
            err_msg,
            { className: "error-toast" }
          );
      }
    },
    onPageChange: async function(page) {
      this.page = page;
      this.fetchCustomer();
    }
  },
  data() {
    return {
      moment: moment,
      customer: {
        name: "",
        phone: "",
        address: "",
        invoices: []
      },
      page: 1,
      sort: {
        value: "created_at",
        direction: "desc"
      },
      loading: false,
      error: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container {
  display: flex;
}
.left-side {
  flex: 1;
  margin-right: 15px;
}
.right-side {
  flex: 2;
}
</style>
